import _ from 'underscore';

(function () {
    "use strict";
    
    var moduleBase = {
        shared: {
            shouldUpdateUrlHash: true,

            getHashValue: function (key) {
                var hash = window.location.hash;

                if (!!hash) {
                    var hashMatches = hash.match(new RegExp(key + '=([^&]*)'));
                    if (hashMatches != null && hashMatches.length > 1) {
                        return hashMatches[1];
                    }
                }
            },

            seedTabFromUrl: function (module) {
                var hashState = moduleBase.shared.getHashValue("tab");

                if (!!hashState) {
                    var $tabHandle = $("[data-tab-handle='" + hashState + "']");
                    $tabHandle.click();
                }
            },

            parseWidgetDataFromJson: function (pageId, blockId) {
                var newQueryString = moduleBase._private.getFullQueryParameters(pageId, blockId);

                var serviceUrl = '/api/FormsDownloadData/' + newQueryString;

                return $.ajax({ url: serviceUrl }).then(function (jsonData) {
                    var data = {};

                    data.formWebAudiences = jsonData.formWebAudienceTerms;

                    _(data.formWebAudiences).each(function (formWebAudience) {
                        var splitName = _(formWebAudience.name.split("-")).chain().invoke("trim").value();
                        var lastIndex = splitName.length - 1;

                        formWebAudience.audienceType = splitName[0].trim();
                        formWebAudience.actionName = splitName.slice(1, lastIndex).join("-").trim();
                        formWebAudience.actionType = splitName[lastIndex].trim();
                    });

                    data.productCategories = jsonData.productCategoryTerms;

                    data.states = jsonData.stateTerms;

                    data.productOfferings = jsonData.partnerFootprint.products;

                    var allProductStates = _(data.productOfferings).chain().pluck("states").flatten().uniq().value();

                    data.states = _(data.states).filter(function (stateObj) {
                        return allProductStates.indexOf(stateObj.guid) != -1;
                    });

                    data.forms = jsonData.forms;

                    _(data.forms).each(function (form) {
                        form.formAudiencesObjects = _(form.formAudiences).chain().map(function (formAudienceGuid) {
                            return _(data.formWebAudiences).findWhere({ guid: formAudienceGuid });
                        }).without(undefined).value();
                    });

                    data.selections = {};

                    return data;
                }, function (response) {
                    console.error("Error getting widget data:", arguments);
                });
            },

            //transaction type name is obsolete
            getApplicableFormsForSelections: function (forms, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid) {
                return moduleBase._private.getApplicableFormsForSelections(forms, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid);
            },

            //obsolete?
            shouldOfferProduct: function (productOfferings, productTermGuid, stateId) {
                return _(productOfferings).any(function (productOffering) {
                    return moduleBase._private.productAppliesToOffering(productOffering, productTermGuid, stateId);
                });
            },

            updateUrlHash: function(selections) {
                if (moduleBase.shared.shouldUpdateUrlHash && !!selections) {
                    var hashArgs = [];

                    if (!!selections.state) {
                        hashArgs.push("state=" + selections.state.guid);
                    }
                    
                    if (!!selections.category) {
                        hashArgs.push("category=" + selections.category.guid);
                    }

                    if (!!selections.subcategory) {
                        hashArgs.push("subcategory=" + selections.subcategory.guid);
                    }

                    if (!!selections.product) {
                        hashArgs.push("product=" + selections.product.guid);
                    }

                    window.location.replace("#" + hashArgs.join("&"));
                }
            }
        },

        _private: {
            getFullQueryParameters: function (pageId, blockId) {
                var hasExistingUrlQuery = (!!window.location.search && window.location.search.length > 0);

                var newQueryArgs = "?";
                var hasFirstArgument = false;

                if (hasExistingUrlQuery) {
                    newQueryArgs = window.location.search;
                    hasFirstArgument = true;
                }

                var newArgs = [{ key: "bust", value: new Date().getTime() },{ key: "pageId", value: pageId }, { key: "blockId", value: blockId }];

                for (var keyValueArgIndex in newArgs) {
                    var keyValueArg = newArgs[keyValueArgIndex];

                    if (hasFirstArgument) {
                        newQueryArgs += "&" + keyValueArg.key + "=" + keyValueArg.value;
                    } else {
                        newQueryArgs += keyValueArg.key + "=" + keyValueArg.value;
                        hasFirstArgument = true;
                    }
                }

                return newQueryArgs;
            },

            isFormValidProductOffering: _.memoize(function (form, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid) {
                if (!!stateGuid) {
                    if (!!productGuid) {
                        var offering = _(productOfferings).findWhere({ guid: productGuid });

                        return !!offering && offering.states.indexOf(stateGuid) != -1;
                    }

                    if (!!categoryGuid) {
                        var categoryTerm = _(productCategories).findWhere({ guid: categoryGuid });

                        if (!!categoryTerm) {
                            var productIds = _(categoryTerm.terms).chain().pluck("terms").flatten().pluck("guid").value();

                            var partialIsValid = _.partial(symetra.formDownloadModuleBase._private.isFormValidProductOffering, form, productCategories, productOfferings, stateGuid, subcategoryGuid, undefined, undefined);

                            var hasValidChildProducts = _(productIds).chain().map(partialIsValid).value();

                            return _(hasValidChildProducts).some();
                        }
                    }

                    if (!!transactionTypeName) {
                        var hasTransactionType = _(form.formAudiencesObjects).some(function (formAudience) {
                            return formAudience.actionName == transactionTypeName;
                        });

                        var hasApplicableState = form.states.indexOf(stateGuid) != -1;

                        return hasTransactionType && hasApplicableState;
                    }
                }

                return false;
            }, function (form, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid) {
                return "validProductOffering" + form.formId + stateGuid + subcategoryGuid + transactionTypeName + categoryGuid + productGuid;
            }),

            isValidProductOffering: function (forms, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid) {
                return _(forms).any(function (form) {
                    return moduleBase._private.isFormValidProductOffering(form, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid);
                });
            },

            //transaction type name is obsolete
            getApplicableFormsForSelections: function (forms, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid) {
                if (!moduleBase._private.isValidProductOffering(forms, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid))
                    return [];

                return _(forms).filter(function (form) {
                    return moduleBase._private.doesFormApplyToSelections(form, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid);
                });
            },

            doesFormApplyToSelections: _.memoize(function (form, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid) {
                var appliesToTransactionTypeFilter = false;
                var hasTransactionType = false;
                var hasApplicableState = false;
                var hasApplicableProduct = false;

                if (!!transactionTypeName) {
                    appliesToTransactionTypeFilter = true;

                    hasTransactionType = _(form.formAudiencesObjects).some(function (formAudience) {
                        return formAudience.actionName == transactionTypeName;
                    });
                }

                hasApplicableState = form.states.indexOf(stateGuid) != -1;

                if (!!productGuid) {
                    // Does state also apply to partner footprint?
                    hasApplicableState = hasApplicableState && _(productOfferings).findWhere({ guid: productGuid }).states.indexOf(stateGuid) != -1;
                }

                if (!!categoryGuid) {
                    if (!!subcategoryGuid) {
                        var productIdentifierPrefix = categoryGuid;

                        if (!!subcategoryGuid) {
                            productIdentifierPrefix = productIdentifierPrefix + "|" + subcategoryGuid;
                        }

                        if (!!productGuid) {
                            productIdentifierPrefix = productIdentifierPrefix + "|" + productGuid;
                        }

                        hasApplicableProduct = _(form.productIdentifiers).some(function (productIdent) {
                            return productIdent.indexOf(productIdentifierPrefix) == 0; // Starts with 
                        });
                    } else {
                        hasApplicableProduct = _(form.productIdentifiers).some(function (productIdent) {
                            var appliesToCategory = productIdent.indexOf(categoryGuid) == 0; // Starts with

                            if (!!productGuid) {
                                var appliesToProduct = productIdent.indexOf(productGuid) == (productIdent.length - productGuid.length);

                                return appliesToCategory && appliesToProduct;
                            }

                            return appliesToCategory;
                        });
                    }

                    if (appliesToTransactionTypeFilter && !hasTransactionType)
                        return false;

                    return hasApplicableState && hasApplicableProduct;
                }

                if (appliesToTransactionTypeFilter && !hasTransactionType)
                    return false;

                return hasApplicableState;

            }, function (form, productCategories, productOfferings, stateGuid, subcategoryGuid, transactionTypeName, categoryGuid, productGuid) {
                return "appliesToSelections" + form.formId + stateGuid + subcategoryGuid + transactionTypeName + categoryGuid + productGuid;
            }),

            //obsolete?
            productAppliesToOffering: _.memoize(function (productOffering, productTermGuid, stateId) {
                return productOffering.guid == productTermGuid && productOffering.states.indexOf(stateId) >= 0;
            }, function (productOffering, productTermGuid, stateId) {
                return "productAppliesToOffering" + productOffering.guid + productTermGuid + stateId;
            }),
        }
    };

    window.symetra.formDownloadModuleBase = moduleBase;
})();